import React, { useMemo } from 'react';
import '../Device/index.js';
import '@magnetic/design-tokens';
import '@phosphor-icons/react';
import '../Phosphor/icons/AddressBook.js';
import '../Phosphor/icons/AirTrafficControl.js';
import '../Phosphor/icons/Airplane.js';
import '../Phosphor/icons/AirplaneInFlight.js';
import '../Phosphor/icons/AirplaneLanding.js';
import '../Phosphor/icons/AirplaneTakeoff.js';
import '../Phosphor/icons/AirplaneTilt.js';
import '../Phosphor/icons/Airplay.js';
import '../Phosphor/icons/Alarm.js';
import '../Phosphor/icons/Alien.js';
import '../Phosphor/icons/AlignBottom.js';
import '../Phosphor/icons/AlignBottomSimple.js';
import '../Phosphor/icons/AlignCenterHorizontal.js';
import '../Phosphor/icons/AlignCenterHorizontalSimple.js';
import '../Phosphor/icons/AlignCenterVertical.js';
import '../Phosphor/icons/AlignCenterVerticalSimple.js';
import '../Phosphor/icons/AlignLeft.js';
import '../Phosphor/icons/AlignLeftSimple.js';
import '../Phosphor/icons/AlignRight.js';
import '../Phosphor/icons/AlignRightSimple.js';
import '../Phosphor/icons/AlignTop.js';
import '../Phosphor/icons/AlignTopSimple.js';
import '../Phosphor/icons/AmazonLogo.js';
import '../Phosphor/icons/Anchor.js';
import '../Phosphor/icons/AnchorSimple.js';
import '../Phosphor/icons/AndroidLogo.js';
import '../Phosphor/icons/AngularLogo.js';
import '../Phosphor/icons/Aperture.js';
import '../Phosphor/icons/AppStoreLogo.js';
import '../Phosphor/icons/AppWindow.js';
import '../Phosphor/icons/AppleLogo.js';
import '../Phosphor/icons/ApplePodcastsLogo.js';
import '../Phosphor/icons/Archive.js';
import '../Phosphor/icons/ArchiveBox.js';
import '../Phosphor/icons/ArchiveTray.js';
import '../Phosphor/icons/Armchair.js';
import '../Phosphor/icons/ArrowArcLeft.js';
import '../Phosphor/icons/ArrowArcRight.js';
import '../Phosphor/icons/ArrowBendDoubleUpLeft.js';
import '../Phosphor/icons/ArrowBendDoubleUpRight.js';
import '../Phosphor/icons/ArrowBendDownLeft.js';
import '../Phosphor/icons/ArrowBendDownRight.js';
import '../Phosphor/icons/ArrowBendLeftDown.js';
import '../Phosphor/icons/ArrowBendLeftUp.js';
import '../Phosphor/icons/ArrowBendRightDown.js';
import '../Phosphor/icons/ArrowBendRightUp.js';
import '../Phosphor/icons/ArrowBendUpLeft.js';
import '../Phosphor/icons/ArrowBendUpRight.js';
import '../Phosphor/icons/ArrowCircleDown.js';
import '../Phosphor/icons/ArrowCircleDownLeft.js';
import '../Phosphor/icons/ArrowCircleDownRight.js';
import '../Phosphor/icons/ArrowCircleLeft.js';
import '../Phosphor/icons/ArrowCircleRight.js';
import '../Phosphor/icons/ArrowCircleUp.js';
import '../Phosphor/icons/ArrowCircleUpLeft.js';
import '../Phosphor/icons/ArrowCircleUpRight.js';
import '../Phosphor/icons/ArrowClockwise.js';
import '../Phosphor/icons/ArrowCounterClockwise.js';
import '../Phosphor/icons/ArrowDown.js';
import '../Phosphor/icons/ArrowDownLeft.js';
import '../Phosphor/icons/ArrowDownRight.js';
import '../Phosphor/icons/ArrowElbowDownLeft.js';
import '../Phosphor/icons/ArrowElbowDownRight.js';
import '../Phosphor/icons/ArrowElbowLeft.js';
import '../Phosphor/icons/ArrowElbowLeftDown.js';
import '../Phosphor/icons/ArrowElbowLeftUp.js';
import '../Phosphor/icons/ArrowElbowRight.js';
import '../Phosphor/icons/ArrowElbowRightDown.js';
import '../Phosphor/icons/ArrowElbowRightUp.js';
import '../Phosphor/icons/ArrowElbowUpLeft.js';
import '../Phosphor/icons/ArrowElbowUpRight.js';
import '../Phosphor/icons/ArrowFatDown.js';
import '../Phosphor/icons/ArrowFatLeft.js';
import '../Phosphor/icons/ArrowFatLineDown.js';
import '../Phosphor/icons/ArrowFatLineLeft.js';
import '../Phosphor/icons/ArrowFatLineRight.js';
import '../Phosphor/icons/ArrowFatLineUp.js';
import '../Phosphor/icons/ArrowFatLinesDown.js';
import '../Phosphor/icons/ArrowFatLinesLeft.js';
import '../Phosphor/icons/ArrowFatLinesRight.js';
import '../Phosphor/icons/ArrowFatLinesUp.js';
import '../Phosphor/icons/ArrowFatRight.js';
import '../Phosphor/icons/ArrowFatUp.js';
import '../Phosphor/icons/ArrowLeft.js';
import '../Phosphor/icons/ArrowLineDown.js';
import '../Phosphor/icons/ArrowLineDownLeft.js';
import '../Phosphor/icons/ArrowLineDownRight.js';
import '../Phosphor/icons/ArrowLineLeft.js';
import '../Phosphor/icons/ArrowLineRight.js';
import '../Phosphor/icons/ArrowLineUp.js';
import '../Phosphor/icons/ArrowLineUpLeft.js';
import '../Phosphor/icons/ArrowLineUpRight.js';
import '../Phosphor/icons/ArrowRight.js';
import '../Phosphor/icons/ArrowSquareDown.js';
import '../Phosphor/icons/ArrowSquareDownLeft.js';
import '../Phosphor/icons/ArrowSquareDownRight.js';
import '../Phosphor/icons/ArrowSquareIn.js';
import '../Phosphor/icons/ArrowSquareLeft.js';
import '../Phosphor/icons/ArrowSquareOut.js';
import '../Phosphor/icons/ArrowSquareRight.js';
import '../Phosphor/icons/ArrowSquareUp.js';
import '../Phosphor/icons/ArrowSquareUpLeft.js';
import '../Phosphor/icons/ArrowSquareUpRight.js';
import '../Phosphor/icons/ArrowUDownLeft.js';
import '../Phosphor/icons/ArrowUDownRight.js';
import '../Phosphor/icons/ArrowULeftDown.js';
import '../Phosphor/icons/ArrowULeftUp.js';
import '../Phosphor/icons/ArrowURightDown.js';
import '../Phosphor/icons/ArrowURightUp.js';
import '../Phosphor/icons/ArrowUUpLeft.js';
import '../Phosphor/icons/ArrowUUpRight.js';
import '../Phosphor/icons/ArrowUp.js';
import '../Phosphor/icons/ArrowUpLeft.js';
import '../Phosphor/icons/ArrowUpRight.js';
import '../Phosphor/icons/ArrowsClockwise.js';
import '../Phosphor/icons/ArrowsCounterClockwise.js';
import '../Phosphor/icons/ArrowsDownUp.js';
import '../Phosphor/icons/ArrowsHorizontal.js';
import '../Phosphor/icons/ArrowsIn.js';
import '../Phosphor/icons/ArrowsInCardinal.js';
import '../Phosphor/icons/ArrowsInLineHorizontal.js';
import '../Phosphor/icons/ArrowsInLineVertical.js';
import '../Phosphor/icons/ArrowsInSimple.js';
import '../Phosphor/icons/ArrowsLeftRight.js';
import '../Phosphor/icons/ArrowsMerge.js';
import '../Phosphor/icons/ArrowsOut.js';
import '../Phosphor/icons/ArrowsOutCardinal.js';
import '../Phosphor/icons/ArrowsOutLineHorizontal.js';
import '../Phosphor/icons/ArrowsOutLineVertical.js';
import '../Phosphor/icons/ArrowsOutSimple.js';
import '../Phosphor/icons/ArrowsSplit.js';
import '../Phosphor/icons/ArrowsVertical.js';
import '../Phosphor/icons/Article.js';
import '../Phosphor/icons/ArticleMedium.js';
import '../Phosphor/icons/ArticleNyTimes.js';
import '../Phosphor/icons/Asterisk.js';
import '../Phosphor/icons/AsteriskSimple.js';
import '../Phosphor/icons/At.js';
import '../Phosphor/icons/Atom.js';
import '../Phosphor/icons/Baby.js';
import '../Phosphor/icons/Backpack.js';
import '../Phosphor/icons/Backspace.js';
import '../Phosphor/icons/Bag.js';
import '../Phosphor/icons/BagSimple.js';
import '../Phosphor/icons/Balloon.js';
import '../Phosphor/icons/Bandaids.js';
import '../Phosphor/icons/Bank.js';
import '../Phosphor/icons/Barbell.js';
import '../Phosphor/icons/Barcode.js';
import '../Phosphor/icons/Barricade.js';
import '../Phosphor/icons/Baseball.js';
import '../Phosphor/icons/BaseballCap.js';
import '../Phosphor/icons/Basket.js';
import '../Phosphor/icons/Basketball.js';
import '../Phosphor/icons/Bathtub.js';
import '../Phosphor/icons/BatteryCharging.js';
import '../Phosphor/icons/BatteryChargingVertical.js';
import '../Phosphor/icons/BatteryEmpty.js';
import '../Phosphor/icons/BatteryFull.js';
import '../Phosphor/icons/BatteryHigh.js';
import '../Phosphor/icons/BatteryLow.js';
import '../Phosphor/icons/BatteryMedium.js';
import '../Phosphor/icons/BatteryPlus.js';
import '../Phosphor/icons/BatteryPlusVertical.js';
import '../Phosphor/icons/BatteryVerticalEmpty.js';
import '../Phosphor/icons/BatteryVerticalFull.js';
import '../Phosphor/icons/BatteryVerticalHigh.js';
import '../Phosphor/icons/BatteryVerticalLow.js';
import '../Phosphor/icons/BatteryVerticalMedium.js';
import '../Phosphor/icons/BatteryWarning.js';
import '../Phosphor/icons/BatteryWarningVertical.js';
import '../Phosphor/icons/Bed.js';
import '../Phosphor/icons/BeerBottle.js';
import '../Phosphor/icons/BeerStein.js';
import '../Phosphor/icons/BehanceLogo.js';
import '../Phosphor/icons/Bell.js';
import '../Phosphor/icons/BellRinging.js';
import '../Phosphor/icons/BellSimple.js';
import '../Phosphor/icons/BellSimpleRinging.js';
import '../Phosphor/icons/BellSimpleSlash.js';
import '../Phosphor/icons/BellSimpleZ.js';
import '../Phosphor/icons/BellSlash.js';
import '../Phosphor/icons/BellZ.js';
import '../Phosphor/icons/BezierCurve.js';
import '../Phosphor/icons/Bicycle.js';
import '../Phosphor/icons/Binoculars.js';
import '../Phosphor/icons/Bird.js';
import '../Phosphor/icons/Bluetooth.js';
import '../Phosphor/icons/BluetoothConnected.js';
import '../Phosphor/icons/BluetoothSlash.js';
import '../Phosphor/icons/BluetoothX.js';
import '../Phosphor/icons/Boat.js';
import '../Phosphor/icons/Bone.js';
import '../Phosphor/icons/Book.js';
import '../Phosphor/icons/BookBookmark.js';
import '../Phosphor/icons/BookOpen.js';
import '../Phosphor/icons/BookOpenText.js';
import '../Phosphor/icons/Bookmark.js';
import '../Phosphor/icons/BookmarkSimple.js';
import '../Phosphor/icons/Bookmarks.js';
import '../Phosphor/icons/BookmarksSimple.js';
import '../Phosphor/icons/Books.js';
import '../Phosphor/icons/Boot.js';
import '../Phosphor/icons/BoundingBox.js';
import '../Phosphor/icons/BowlFood.js';
import '../Phosphor/icons/BracketsAngle.js';
import '../Phosphor/icons/BracketsCurly.js';
import '../Phosphor/icons/BracketsRound.js';
import '../Phosphor/icons/BracketsSquare.js';
import '../Phosphor/icons/Brain.js';
import '../Phosphor/icons/Brandy.js';
import '../Phosphor/icons/Bridge.js';
import '../Phosphor/icons/Briefcase.js';
import '../Phosphor/icons/BriefcaseMetal.js';
import '../Phosphor/icons/Broadcast.js';
import '../Phosphor/icons/Broom.js';
import '../Phosphor/icons/Browser.js';
import '../Phosphor/icons/Browsers.js';
import '../Phosphor/icons/Bug.js';
import '../Phosphor/icons/BugBeetle.js';
import '../Phosphor/icons/BugDroid.js';
import '../Phosphor/icons/Buildings.js';
import '../Phosphor/icons/Bus.js';
import '../Phosphor/icons/Butterfly.js';
import '../Phosphor/icons/Cactus.js';
import '../Phosphor/icons/Cake.js';
import '../Phosphor/icons/Calculator.js';
import '../Phosphor/icons/Calendar.js';
import '../Phosphor/icons/CalendarBlank.js';
import '../Phosphor/icons/CalendarCheck.js';
import '../Phosphor/icons/CalendarPlus.js';
import '../Phosphor/icons/CalendarX.js';
import '../Phosphor/icons/CallBell.js';
import '../Phosphor/icons/Camera.js';
import '../Phosphor/icons/CameraPlus.js';
import '../Phosphor/icons/CameraRotate.js';
import '../Phosphor/icons/CameraSlash.js';
import '../Phosphor/icons/Campfire.js';
import '../Phosphor/icons/Car.js';
import '../Phosphor/icons/CarProfile.js';
import '../Phosphor/icons/CarSimple.js';
import '../Phosphor/icons/Cardholder.js';
import '../Phosphor/icons/Cards.js';
import '../Phosphor/icons/CaretCircleDoubleDown.js';
import '../Phosphor/icons/CaretCircleDoubleLeft.js';
import '../Phosphor/icons/CaretCircleDoubleRight.js';
import '../Phosphor/icons/CaretCircleDoubleUp.js';
import '../Phosphor/icons/CaretCircleDown.js';
import '../Phosphor/icons/CaretCircleLeft.js';
import '../Phosphor/icons/CaretCircleRight.js';
import '../Phosphor/icons/CaretCircleUp.js';
import '../Phosphor/icons/CaretCircleUpDown.js';
import '../Phosphor/icons/CaretDoubleDown.js';
import '../Phosphor/icons/CaretDoubleLeft.js';
import '../Phosphor/icons/CaretDoubleRight.js';
import '../Phosphor/icons/CaretDoubleUp.js';
import '../Phosphor/icons/CaretDown.js';
import '../Phosphor/icons/CaretLeft.js';
import '../Phosphor/icons/CaretRight.js';
import '../Phosphor/icons/CaretUp.js';
import '../Phosphor/icons/CaretUpDown.js';
import '../Phosphor/icons/Carrot.js';
import '../Phosphor/icons/CassetteTape.js';
import '../Phosphor/icons/CastleTurret.js';
import '../Phosphor/icons/Cat.js';
import '../Phosphor/icons/CellSignalFull.js';
import '../Phosphor/icons/CellSignalHigh.js';
import '../Phosphor/icons/CellSignalLow.js';
import '../Phosphor/icons/CellSignalMedium.js';
import '../Phosphor/icons/CellSignalNone.js';
import '../Phosphor/icons/CellSignalSlash.js';
import '../Phosphor/icons/CellSignalX.js';
import '../Phosphor/icons/Certificate.js';
import '../Phosphor/icons/Chair.js';
import '../Phosphor/icons/Chalkboard.js';
import '../Phosphor/icons/ChalkboardSimple.js';
import '../Phosphor/icons/ChalkboardTeacher.js';
import '../Phosphor/icons/Champagne.js';
import '../Phosphor/icons/ChargingStation.js';
import '../Phosphor/icons/ChartBar.js';
import '../Phosphor/icons/ChartBarHorizontal.js';
import '../Phosphor/icons/ChartDonut.js';
import '../Phosphor/icons/ChartLine.js';
import '../Phosphor/icons/ChartLineDown.js';
import '../Phosphor/icons/ChartLineUp.js';
import '../Phosphor/icons/ChartPie.js';
import '../Phosphor/icons/ChartPieSlice.js';
import '../Phosphor/icons/ChartPolar.js';
import '../Phosphor/icons/ChartScatter.js';
import '../Phosphor/icons/Chat.js';
import '../Phosphor/icons/ChatCentered.js';
import '../Phosphor/icons/ChatCenteredDots.js';
import '../Phosphor/icons/ChatCenteredText.js';
import '../Phosphor/icons/ChatCircle.js';
import '../Phosphor/icons/ChatCircleDots.js';
import '../Phosphor/icons/ChatCircleText.js';
import '../Phosphor/icons/ChatDots.js';
import '../Phosphor/icons/ChatTeardrop.js';
import '../Phosphor/icons/ChatTeardropDots.js';
import '../Phosphor/icons/ChatTeardropText.js';
import '../Phosphor/icons/ChatText.js';
import '../Phosphor/icons/Chats.js';
import '../Phosphor/icons/ChatsCircle.js';
import '../Phosphor/icons/ChatsTeardrop.js';
import '../Phosphor/icons/Check.js';
import '../Phosphor/icons/CheckCircle.js';
import '../Phosphor/icons/CheckFat.js';
import '../Phosphor/icons/CheckSquare.js';
import '../Phosphor/icons/CheckSquareOffset.js';
import '../Phosphor/icons/Checks.js';
import '../Phosphor/icons/Church.js';
import '../Phosphor/icons/Circle.js';
import '../Phosphor/icons/CircleDashed.js';
import '../Phosphor/icons/CircleHalf.js';
import '../Phosphor/icons/CircleHalfTilt.js';
import '../Phosphor/icons/CircleNotch.js';
import '../Phosphor/icons/CirclesFour.js';
import '../Phosphor/icons/CirclesThree.js';
import '../Phosphor/icons/CirclesThreePlus.js';
import '../Phosphor/icons/Circuitry.js';
import '../Phosphor/icons/Clipboard.js';
import '../Phosphor/icons/ClipboardText.js';
import '../Phosphor/icons/Clock.js';
import '../Phosphor/icons/ClockAfternoon.js';
import '../Phosphor/icons/ClockClockwise.js';
import '../Phosphor/icons/ClockCountdown.js';
import '../Phosphor/icons/ClockCounterClockwise.js';
import '../Phosphor/icons/ClosedCaptioning.js';
import '../Phosphor/icons/Cloud.js';
import '../Phosphor/icons/CloudArrowDown.js';
import '../Phosphor/icons/CloudArrowUp.js';
import '../Phosphor/icons/CloudCheck.js';
import '../Phosphor/icons/CloudFog.js';
import '../Phosphor/icons/CloudLightning.js';
import '../Phosphor/icons/CloudMoon.js';
import '../Phosphor/icons/CloudRain.js';
import '../Phosphor/icons/CloudSlash.js';
import '../Phosphor/icons/CloudSnow.js';
import '../Phosphor/icons/CloudSun.js';
import '../Phosphor/icons/CloudWarning.js';
import '../Phosphor/icons/CloudX.js';
import '../Phosphor/icons/Club.js';
import '../Phosphor/icons/CoatHanger.js';
import '../Phosphor/icons/CodaLogo.js';
import '../Phosphor/icons/Code.js';
import '../Phosphor/icons/CodeBlock.js';
import '../Phosphor/icons/CodeSimple.js';
import '../Phosphor/icons/CodepenLogo.js';
import '../Phosphor/icons/CodesandboxLogo.js';
import '../Phosphor/icons/Coffee.js';
import '../Phosphor/icons/Coin.js';
import '../Phosphor/icons/CoinVertical.js';
import '../Phosphor/icons/Coins.js';
import '../Phosphor/icons/Columns.js';
import '../Phosphor/icons/Command.js';
import '../Phosphor/icons/Compass.js';
import '../Phosphor/icons/CompassTool.js';
import '../Phosphor/icons/ComputerTower.js';
import '../Phosphor/icons/Confetti.js';
import '../Phosphor/icons/ContactlessPayment.js';
import '../Phosphor/icons/Control.js';
import '../Phosphor/icons/Cookie.js';
import '../Phosphor/icons/CookingPot.js';
import '../Phosphor/icons/Copy.js';
import '../Phosphor/icons/CopySimple.js';
import '../Phosphor/icons/Copyleft.js';
import '../Phosphor/icons/Copyright.js';
import '../Phosphor/icons/CornersIn.js';
import '../Phosphor/icons/CornersOut.js';
import '../Phosphor/icons/Couch.js';
import '../Phosphor/icons/Cpu.js';
import '../Phosphor/icons/CreditCard.js';
import '../Phosphor/icons/Crop.js';
import '../Phosphor/icons/Cross.js';
import '../Phosphor/icons/Crosshair.js';
import '../Phosphor/icons/CrosshairSimple.js';
import '../Phosphor/icons/Crown.js';
import '../Phosphor/icons/CrownSimple.js';
import '../Phosphor/icons/Cube.js';
import '../Phosphor/icons/CubeFocus.js';
import '../Phosphor/icons/CubeTransparent.js';
import '../Phosphor/icons/CurrencyBtc.js';
import '../Phosphor/icons/CurrencyCircleDollar.js';
import '../Phosphor/icons/CurrencyCny.js';
import '../Phosphor/icons/CurrencyDollar.js';
import '../Phosphor/icons/CurrencyDollarSimple.js';
import '../Phosphor/icons/CurrencyEth.js';
import '../Phosphor/icons/CurrencyEur.js';
import '../Phosphor/icons/CurrencyGbp.js';
import '../Phosphor/icons/CurrencyInr.js';
import '../Phosphor/icons/CurrencyJpy.js';
import '../Phosphor/icons/CurrencyKrw.js';
import '../Phosphor/icons/CurrencyKzt.js';
import '../Phosphor/icons/CurrencyNgn.js';
import '../Phosphor/icons/CurrencyRub.js';
import '../Phosphor/icons/Cursor.js';
import '../Phosphor/icons/CursorClick.js';
import '../Phosphor/icons/CursorText.js';
import '../Phosphor/icons/Cylinder.js';
import '../Phosphor/icons/Database.js';
import '../Phosphor/icons/Desktop.js';
import '../Phosphor/icons/DesktopTower.js';
import '../Phosphor/icons/Detective.js';
import '../Phosphor/icons/DevToLogo.js';
import '../Phosphor/icons/DeviceMobile.js';
import '../Phosphor/icons/DeviceMobileCamera.js';
import '../Phosphor/icons/DeviceMobileSpeaker.js';
import '../Phosphor/icons/DeviceTablet.js';
import '../Phosphor/icons/DeviceTabletCamera.js';
import '../Phosphor/icons/DeviceTabletSpeaker.js';
import '../Phosphor/icons/Devices.js';
import '../Phosphor/icons/Diamond.js';
import '../Phosphor/icons/DiamondsFour.js';
import '../Phosphor/icons/DiceFive.js';
import '../Phosphor/icons/DiceFour.js';
import '../Phosphor/icons/DiceOne.js';
import '../Phosphor/icons/DiceSix.js';
import '../Phosphor/icons/DiceThree.js';
import '../Phosphor/icons/DiceTwo.js';
import '../Phosphor/icons/Disc.js';
import '../Phosphor/icons/DiscordLogo.js';
import '../Phosphor/icons/Divide.js';
import '../Phosphor/icons/Dna.js';
import '../Phosphor/icons/Dog.js';
import '../Phosphor/icons/Door.js';
import '../Phosphor/icons/DoorOpen.js';
import '../Phosphor/icons/Dot.js';
import '../Phosphor/icons/DotOutline.js';
import '../Phosphor/icons/DotsNine.js';
import '../Phosphor/icons/DotsSix.js';
import '../Phosphor/icons/DotsSixVertical.js';
import '../Phosphor/icons/DotsThree.js';
import '../Phosphor/icons/DotsThreeCircle.js';
import '../Phosphor/icons/DotsThreeCircleVertical.js';
import '../Phosphor/icons/DotsThreeOutline.js';
import '../Phosphor/icons/DotsThreeOutlineVertical.js';
import '../Phosphor/icons/DotsThreeVertical.js';
import '../Phosphor/icons/Download.js';
import '../Phosphor/icons/DownloadSimple.js';
import '../Phosphor/icons/Dress.js';
import '../Phosphor/icons/DribbbleLogo.js';
import '../Phosphor/icons/Drop.js';
import '../Phosphor/icons/DropHalf.js';
import '../Phosphor/icons/DropHalfBottom.js';
import '../Phosphor/icons/DropboxLogo.js';
import '../Phosphor/icons/Ear.js';
import '../Phosphor/icons/EarSlash.js';
import '../Phosphor/icons/Egg.js';
import '../Phosphor/icons/EggCrack.js';
import '../Phosphor/icons/Eject.js';
import '../Phosphor/icons/EjectSimple.js';
import '../Phosphor/icons/Elevator.js';
import '../Phosphor/icons/Engine.js';
import '../Phosphor/icons/Envelope.js';
import '../Phosphor/icons/EnvelopeOpen.js';
import '../Phosphor/icons/EnvelopeSimple.js';
import '../Phosphor/icons/EnvelopeSimpleOpen.js';
import '../Phosphor/icons/Equalizer.js';
import '../Phosphor/icons/Equals.js';
import '../Phosphor/icons/Eraser.js';
import '../Phosphor/icons/EscalatorDown.js';
import '../Phosphor/icons/EscalatorUp.js';
import '../Phosphor/icons/Exam.js';
import '../Phosphor/icons/Exclude.js';
import '../Phosphor/icons/ExcludeSquare.js';
import '../Phosphor/icons/Export.js';
import '../Phosphor/icons/Eye.js';
import '../Phosphor/icons/EyeClosed.js';
import '../Phosphor/icons/EyeSlash.js';
import '../Phosphor/icons/Eyedropper.js';
import '../Phosphor/icons/EyedropperSample.js';
import '../Phosphor/icons/Eyeglasses.js';
import '../Phosphor/icons/FaceMask.js';
import '../Phosphor/icons/FacebookLogo.js';
import '../Phosphor/icons/Factory.js';
import '../Phosphor/icons/Faders.js';
import '../Phosphor/icons/FadersHorizontal.js';
import '../Phosphor/icons/Fan.js';
import '../Phosphor/icons/FastForward.js';
import '../Phosphor/icons/FastForwardCircle.js';
import '../Phosphor/icons/Feather.js';
import '../Phosphor/icons/FigmaLogo.js';
import '../Phosphor/icons/File.js';
import '../Phosphor/icons/FileArchive.js';
import '../Phosphor/icons/FileArrowDown.js';
import '../Phosphor/icons/FileArrowUp.js';
import '../Phosphor/icons/FileAudio.js';
import '../Phosphor/icons/FileCloud.js';
import '../Phosphor/icons/FileCode.js';
import '../Phosphor/icons/FileCss.js';
import '../Phosphor/icons/FileCsv.js';
import '../Phosphor/icons/FileDashed.js';
import '../Phosphor/icons/FileDoc.js';
import '../Phosphor/icons/FileHtml.js';
import '../Phosphor/icons/FileImage.js';
import '../Phosphor/icons/FileJpg.js';
import '../Phosphor/icons/FileJs.js';
import '../Phosphor/icons/FileJsx.js';
import '../Phosphor/icons/FileLock.js';
import '../Phosphor/icons/FileMagnifyingGlass.js';
import '../Phosphor/icons/FileMinus.js';
import '../Phosphor/icons/FilePdf.js';
import '../Phosphor/icons/FilePlus.js';
import '../Phosphor/icons/FilePng.js';
import '../Phosphor/icons/FilePpt.js';
import '../Phosphor/icons/FileRs.js';
import '../Phosphor/icons/FileSql.js';
import '../Phosphor/icons/FileSvg.js';
import '../Phosphor/icons/FileText.js';
import '../Phosphor/icons/FileTs.js';
import '../Phosphor/icons/FileTsx.js';
import '../Phosphor/icons/FileVideo.js';
import '../Phosphor/icons/FileVue.js';
import '../Phosphor/icons/FileX.js';
import '../Phosphor/icons/FileXls.js';
import '../Phosphor/icons/FileZip.js';
import '../Phosphor/icons/Files.js';
import '../Phosphor/icons/FilmReel.js';
import '../Phosphor/icons/FilmScript.js';
import '../Phosphor/icons/FilmSlate.js';
import '../Phosphor/icons/FilmStrip.js';
import '../Phosphor/icons/Fingerprint.js';
import '../Phosphor/icons/FingerprintSimple.js';
import '../Phosphor/icons/FinnTheHuman.js';
import '../Phosphor/icons/Fire.js';
import '../Phosphor/icons/FireExtinguisher.js';
import '../Phosphor/icons/FireSimple.js';
import '../Phosphor/icons/FirstAid.js';
import '../Phosphor/icons/FirstAidKit.js';
import '../Phosphor/icons/Fish.js';
import '../Phosphor/icons/FishSimple.js';
import '../Phosphor/icons/Flag.js';
import '../Phosphor/icons/FlagBanner.js';
import '../Phosphor/icons/FlagCheckered.js';
import '../Phosphor/icons/FlagPennant.js';
import '../Phosphor/icons/Flame.js';
import '../Phosphor/icons/Flashlight.js';
import '../Phosphor/icons/Flask.js';
import '../Phosphor/icons/FloppyDisk.js';
import '../Phosphor/icons/FloppyDiskBack.js';
import '../Phosphor/icons/FlowArrow.js';
import '../Phosphor/icons/Flower.js';
import '../Phosphor/icons/FlowerLotus.js';
import '../Phosphor/icons/FlowerTulip.js';
import '../Phosphor/icons/FlyingSaucer.js';
import '../Phosphor/icons/Folder.js';
import '../Phosphor/icons/FolderDashed.js';
import '../Phosphor/icons/FolderLock.js';
import '../Phosphor/icons/FolderMinus.js';
import '../Phosphor/icons/FolderNotch.js';
import '../Phosphor/icons/FolderNotchMinus.js';
import '../Phosphor/icons/FolderNotchOpen.js';
import '../Phosphor/icons/FolderNotchPlus.js';
import '../Phosphor/icons/FolderOpen.js';
import '../Phosphor/icons/FolderPlus.js';
import '../Phosphor/icons/FolderSimple.js';
import '../Phosphor/icons/FolderSimpleDashed.js';
import '../Phosphor/icons/FolderSimpleLock.js';
import '../Phosphor/icons/FolderSimpleMinus.js';
import '../Phosphor/icons/FolderSimplePlus.js';
import '../Phosphor/icons/FolderSimpleStar.js';
import '../Phosphor/icons/FolderSimpleUser.js';
import '../Phosphor/icons/FolderStar.js';
import '../Phosphor/icons/FolderUser.js';
import '../Phosphor/icons/Folders.js';
import '../Phosphor/icons/Football.js';
import '../Phosphor/icons/Footprints.js';
import '../Phosphor/icons/ForkKnife.js';
import '../Phosphor/icons/FrameCorners.js';
import '../Phosphor/icons/FramerLogo.js';
import '../Phosphor/icons/Function.js';
import '../Phosphor/icons/Funnel.js';
import '../Phosphor/icons/FunnelSimple.js';
import '../Phosphor/icons/GameController.js';
import '../Phosphor/icons/Garage.js';
import '../Phosphor/icons/GasCan.js';
import '../Phosphor/icons/GasPump.js';
import '../Phosphor/icons/Gauge.js';
import '../Phosphor/icons/Gavel.js';
import '../Phosphor/icons/Gear.js';
import '../Phosphor/icons/GearFine.js';
import '../Phosphor/icons/GearSix.js';
import '../Phosphor/icons/GenderFemale.js';
import '../Phosphor/icons/GenderIntersex.js';
import '../Phosphor/icons/GenderMale.js';
import '../Phosphor/icons/GenderNeuter.js';
import '../Phosphor/icons/GenderNonbinary.js';
import '../Phosphor/icons/GenderTransgender.js';
import '../Phosphor/icons/Ghost.js';
import '../Phosphor/icons/Gif.js';
import '../Phosphor/icons/Gift.js';
import '../Phosphor/icons/GitBranch.js';
import '../Phosphor/icons/GitCommit.js';
import '../Phosphor/icons/GitDiff.js';
import '../Phosphor/icons/GitFork.js';
import '../Phosphor/icons/GitMerge.js';
import '../Phosphor/icons/GitPullRequest.js';
import '../Phosphor/icons/GithubLogo.js';
import '../Phosphor/icons/GitlabLogo.js';
import '../Phosphor/icons/GitlabLogoSimple.js';
import '../Phosphor/icons/Globe.js';
import '../Phosphor/icons/GlobeHemisphereEast.js';
import '../Phosphor/icons/GlobeHemisphereWest.js';
import '../Phosphor/icons/GlobeSimple.js';
import '../Phosphor/icons/GlobeStand.js';
import '../Phosphor/icons/Goggles.js';
import '../Phosphor/icons/GoodreadsLogo.js';
import '../Phosphor/icons/GoogleCardboardLogo.js';
import '../Phosphor/icons/GoogleChromeLogo.js';
import '../Phosphor/icons/GoogleDriveLogo.js';
import '../Phosphor/icons/GoogleLogo.js';
import '../Phosphor/icons/GooglePhotosLogo.js';
import '../Phosphor/icons/GooglePlayLogo.js';
import '../Phosphor/icons/GooglePodcastsLogo.js';
import '../Phosphor/icons/Gradient.js';
import '../Phosphor/icons/GraduationCap.js';
import '../Phosphor/icons/Grains.js';
import '../Phosphor/icons/GrainsSlash.js';
import '../Phosphor/icons/Graph.js';
import '../Phosphor/icons/GridFour.js';
import '../Phosphor/icons/GridNine.js';
import '../Phosphor/icons/Guitar.js';
import '../Phosphor/icons/Hamburger.js';
import '../Phosphor/icons/Hammer.js';
import '../Phosphor/icons/Hand.js';
import '../Phosphor/icons/HandCoins.js';
import '../Phosphor/icons/HandEye.js';
import '../Phosphor/icons/HandFist.js';
import '../Phosphor/icons/HandGrabbing.js';
import '../Phosphor/icons/HandHeart.js';
import '../Phosphor/icons/HandPalm.js';
import '../Phosphor/icons/HandPointing.js';
import '../Phosphor/icons/HandSoap.js';
import '../Phosphor/icons/HandSwipeLeft.js';
import '../Phosphor/icons/HandSwipeRight.js';
import '../Phosphor/icons/HandTap.js';
import '../Phosphor/icons/HandWaving.js';
import '../Phosphor/icons/Handbag.js';
import '../Phosphor/icons/HandbagSimple.js';
import '../Phosphor/icons/HandsClapping.js';
import '../Phosphor/icons/HandsPraying.js';
import '../Phosphor/icons/Handshake.js';
import '../Phosphor/icons/HardDrive.js';
import '../Phosphor/icons/HardDrives.js';
import '../Phosphor/icons/Hash.js';
import '../Phosphor/icons/HashStraight.js';
import '../Phosphor/icons/Headlights.js';
import '../Phosphor/icons/Headphones.js';
import '../Phosphor/icons/Headset.js';
import '../Phosphor/icons/Heart.js';
import '../Phosphor/icons/HeartBreak.js';
import '../Phosphor/icons/HeartHalf.js';
import '../Phosphor/icons/HeartStraight.js';
import '../Phosphor/icons/HeartStraightBreak.js';
import '../Phosphor/icons/Heartbeat.js';
import '../Phosphor/icons/Hexagon.js';
import '../Phosphor/icons/HighHeel.js';
import '../Phosphor/icons/HighlighterCircle.js';
import '../Phosphor/icons/Hoodie.js';
import '../Phosphor/icons/Horse.js';
import '../Phosphor/icons/Hourglass.js';
import '../Phosphor/icons/HourglassHigh.js';
import '../Phosphor/icons/HourglassLow.js';
import '../Phosphor/icons/HourglassMedium.js';
import '../Phosphor/icons/HourglassSimple.js';
import '../Phosphor/icons/HourglassSimpleHigh.js';
import '../Phosphor/icons/HourglassSimpleLow.js';
import '../Phosphor/icons/HourglassSimpleMedium.js';
import '../Phosphor/icons/House.js';
import '../Phosphor/icons/HouseLine.js';
import '../Phosphor/icons/HouseSimple.js';
import '../Phosphor/icons/IceCream.js';
import '../Phosphor/icons/IdentificationBadge.js';
import '../Phosphor/icons/IdentificationCard.js';
import '../Phosphor/icons/Image.js';
import '../Phosphor/icons/ImageSquare.js';
import '../Phosphor/icons/Images.js';
import '../Phosphor/icons/ImagesSquare.js';
import '../Phosphor/icons/Infinity.js';
import '../Phosphor/icons/Info.js';
import '../Phosphor/icons/InstagramLogo.js';
import '../Phosphor/icons/Intersect.js';
import '../Phosphor/icons/IntersectSquare.js';
import '../Phosphor/icons/IntersectThree.js';
import '../Phosphor/icons/Jeep.js';
import '../Phosphor/icons/Kanban.js';
import '../Phosphor/icons/Key.js';
import '../Phosphor/icons/KeyReturn.js';
import '../Phosphor/icons/Keyboard.js';
import '../Phosphor/icons/Keyhole.js';
import '../Phosphor/icons/Knife.js';
import '../Phosphor/icons/Ladder.js';
import '../Phosphor/icons/LadderSimple.js';
import '../Phosphor/icons/Lamp.js';
import '../Phosphor/icons/Laptop.js';
import '../Phosphor/icons/Layout.js';
import '../Phosphor/icons/Leaf.js';
import '../Phosphor/icons/Lifebuoy.js';
import '../Phosphor/icons/Lightbulb.js';
import '../Phosphor/icons/LightbulbFilament.js';
import '../Phosphor/icons/Lighthouse.js';
import '../Phosphor/icons/Lightning.js';
import '../Phosphor/icons/LightningA.js';
import '../Phosphor/icons/LightningSlash.js';
import '../Phosphor/icons/LineSegment.js';
import '../Phosphor/icons/LineSegments.js';
import '../Phosphor/icons/Link.js';
import '../Phosphor/icons/LinkBreak.js';
import '../Phosphor/icons/LinkSimple.js';
import '../Phosphor/icons/LinkSimpleBreak.js';
import '../Phosphor/icons/LinkSimpleHorizontal.js';
import '../Phosphor/icons/LinkSimpleHorizontalBreak.js';
import '../Phosphor/icons/LinkedinLogo.js';
import '../Phosphor/icons/LinuxLogo.js';
import '../Phosphor/icons/List.js';
import '../Phosphor/icons/ListBullets.js';
import '../Phosphor/icons/ListChecks.js';
import '../Phosphor/icons/ListDashes.js';
import '../Phosphor/icons/ListMagnifyingGlass.js';
import '../Phosphor/icons/ListNumbers.js';
import '../Phosphor/icons/ListPlus.js';
import '../Phosphor/icons/Lock.js';
import '../Phosphor/icons/LockKey.js';
import '../Phosphor/icons/LockKeyOpen.js';
import '../Phosphor/icons/LockLaminated.js';
import '../Phosphor/icons/LockLaminatedOpen.js';
import '../Phosphor/icons/LockOpen.js';
import '../Phosphor/icons/LockSimple.js';
import '../Phosphor/icons/LockSimpleOpen.js';
import '../Phosphor/icons/Lockers.js';
import '../Phosphor/icons/MagicWand.js';
import '../Phosphor/icons/Magnet.js';
import '../Phosphor/icons/MagnetStraight.js';
import '../Phosphor/icons/MagnifyingGlass.js';
import '../Phosphor/icons/MagnifyingGlassMinus.js';
import '../Phosphor/icons/MagnifyingGlassPlus.js';
import '../Phosphor/icons/MapPin.js';
import '../Phosphor/icons/MapPinLine.js';
import '../Phosphor/icons/MapTrifold.js';
import '../Phosphor/icons/MarkerCircle.js';
import '../Phosphor/icons/Martini.js';
import '../Phosphor/icons/MaskHappy.js';
import '../Phosphor/icons/MaskSad.js';
import '../Phosphor/icons/MathOperations.js';
import '../Phosphor/icons/Medal.js';
import '../Phosphor/icons/MedalMilitary.js';
import '../Phosphor/icons/MediumLogo.js';
import '../Phosphor/icons/Megaphone.js';
import '../Phosphor/icons/MegaphoneSimple.js';
import '../Phosphor/icons/MessengerLogo.js';
import '../Phosphor/icons/MetaLogo.js';
import '../Phosphor/icons/Metronome.js';
import '../Phosphor/icons/Microphone.js';
import '../Phosphor/icons/MicrophoneSlash.js';
import '../Phosphor/icons/MicrophoneStage.js';
import '../Phosphor/icons/MicrosoftExcelLogo.js';
import '../Phosphor/icons/MicrosoftOutlookLogo.js';
import '../Phosphor/icons/MicrosoftPowerpointLogo.js';
import '../Phosphor/icons/MicrosoftTeamsLogo.js';
import '../Phosphor/icons/MicrosoftWordLogo.js';
import '../Phosphor/icons/Minus.js';
import '../Phosphor/icons/MinusCircle.js';
import '../Phosphor/icons/MinusSquare.js';
import '../Phosphor/icons/Money.js';
import '../Phosphor/icons/Monitor.js';
import '../Phosphor/icons/MonitorPlay.js';
import '../Phosphor/icons/Moon.js';
import '../Phosphor/icons/MoonStars.js';
import '../Phosphor/icons/Moped.js';
import '../Phosphor/icons/MopedFront.js';
import '../Phosphor/icons/Mosque.js';
import '../Phosphor/icons/Motorcycle.js';
import '../Phosphor/icons/Mountains.js';
import '../Phosphor/icons/Mouse.js';
import '../Phosphor/icons/MouseSimple.js';
import '../Phosphor/icons/MusicNote.js';
import '../Phosphor/icons/MusicNoteSimple.js';
import '../Phosphor/icons/MusicNotes.js';
import '../Phosphor/icons/MusicNotesPlus.js';
import '../Phosphor/icons/MusicNotesSimple.js';
import '../Phosphor/icons/NavigationArrow.js';
import '../Phosphor/icons/Needle.js';
import '../Phosphor/icons/Newspaper.js';
import '../Phosphor/icons/NewspaperClipping.js';
import '../Phosphor/icons/Notches.js';
import '../Phosphor/icons/Note.js';
import '../Phosphor/icons/NoteBlank.js';
import '../Phosphor/icons/NotePencil.js';
import '../Phosphor/icons/Notebook.js';
import '../Phosphor/icons/Notepad.js';
import '../Phosphor/icons/Notification.js';
import '../Phosphor/icons/NotionLogo.js';
import '../Phosphor/icons/NumberCircleEight.js';
import '../Phosphor/icons/NumberCircleFive.js';
import '../Phosphor/icons/NumberCircleFour.js';
import '../Phosphor/icons/NumberCircleNine.js';
import '../Phosphor/icons/NumberCircleOne.js';
import '../Phosphor/icons/NumberCircleSeven.js';
import '../Phosphor/icons/NumberCircleSix.js';
import '../Phosphor/icons/NumberCircleThree.js';
import '../Phosphor/icons/NumberCircleTwo.js';
import '../Phosphor/icons/NumberCircleZero.js';
import '../Phosphor/icons/NumberEight.js';
import '../Phosphor/icons/NumberFive.js';
import '../Phosphor/icons/NumberFour.js';
import '../Phosphor/icons/NumberNine.js';
import '../Phosphor/icons/NumberOne.js';
import '../Phosphor/icons/NumberSeven.js';
import '../Phosphor/icons/NumberSix.js';
import '../Phosphor/icons/NumberSquareEight.js';
import '../Phosphor/icons/NumberSquareFive.js';
import '../Phosphor/icons/NumberSquareFour.js';
import '../Phosphor/icons/NumberSquareNine.js';
import '../Phosphor/icons/NumberSquareOne.js';
import '../Phosphor/icons/NumberSquareSeven.js';
import '../Phosphor/icons/NumberSquareSix.js';
import '../Phosphor/icons/NumberSquareThree.js';
import '../Phosphor/icons/NumberSquareTwo.js';
import '../Phosphor/icons/NumberSquareZero.js';
import '../Phosphor/icons/NumberThree.js';
import '../Phosphor/icons/NumberTwo.js';
import '../Phosphor/icons/NumberZero.js';
import '../Phosphor/icons/Nut.js';
import '../Phosphor/icons/NyTimesLogo.js';
import '../Phosphor/icons/Octagon.js';
import '../Phosphor/icons/OfficeChair.js';
import '../Phosphor/icons/Option.js';
import '../Phosphor/icons/OrangeSlice.js';
import '../Phosphor/icons/Package.js';
import '../Phosphor/icons/PaintBrush.js';
import '../Phosphor/icons/PaintBrushBroad.js';
import '../Phosphor/icons/PaintBrushHousehold.js';
import '../Phosphor/icons/PaintBucket.js';
import '../Phosphor/icons/PaintRoller.js';
import '../Phosphor/icons/Palette.js';
import '../Phosphor/icons/Pants.js';
import '../Phosphor/icons/PaperPlane.js';
import '../Phosphor/icons/PaperPlaneRight.js';
import '../Phosphor/icons/PaperPlaneTilt.js';
import '../Phosphor/icons/Paperclip.js';
import '../Phosphor/icons/PaperclipHorizontal.js';
import '../Phosphor/icons/Parachute.js';
import '../Phosphor/icons/Paragraph.js';
import '../Phosphor/icons/Parallelogram.js';
import '../Phosphor/icons/Park.js';
import '../Phosphor/icons/Password.js';
import '../Phosphor/icons/Path.js';
import '../Phosphor/icons/PatreonLogo.js';
import '../Phosphor/icons/Pause.js';
import '../Phosphor/icons/PauseCircle.js';
import '../Phosphor/icons/PawPrint.js';
import '../Phosphor/icons/PaypalLogo.js';
import '../Phosphor/icons/Peace.js';
import '../Phosphor/icons/Pen.js';
import '../Phosphor/icons/PenNib.js';
import '../Phosphor/icons/PenNibStraight.js';
import '../Phosphor/icons/Pencil.js';
import '../Phosphor/icons/PencilCircle.js';
import '../Phosphor/icons/PencilLine.js';
import '../Phosphor/icons/PencilSimple.js';
import '../Phosphor/icons/PencilSimpleLine.js';
import '../Phosphor/icons/PencilSimpleSlash.js';
import '../Phosphor/icons/PencilSlash.js';
import '../Phosphor/icons/Pentagram.js';
import '../Phosphor/icons/Pepper.js';
import '../Phosphor/icons/Percent.js';
import '../Phosphor/icons/Person.js';
import '../Phosphor/icons/PersonArmsSpread.js';
import '../Phosphor/icons/PersonSimple.js';
import '../Phosphor/icons/PersonSimpleBike.js';
import '../Phosphor/icons/PersonSimpleRun.js';
import '../Phosphor/icons/PersonSimpleThrow.js';
import '../Phosphor/icons/PersonSimpleWalk.js';
import '../Phosphor/icons/Perspective.js';
import '../Phosphor/icons/Phone.js';
import '../Phosphor/icons/PhoneCall.js';
import '../Phosphor/icons/PhoneDisconnect.js';
import '../Phosphor/icons/PhoneIncoming.js';
import '../Phosphor/icons/PhoneOutgoing.js';
import '../Phosphor/icons/PhonePlus.js';
import '../Phosphor/icons/PhoneSlash.js';
import '../Phosphor/icons/PhoneX.js';
import '../Phosphor/icons/PhosphorLogo.js';
import '../Phosphor/icons/Pi.js';
import '../Phosphor/icons/PianoKeys.js';
import '../Phosphor/icons/PictureInPicture.js';
import '../Phosphor/icons/PiggyBank.js';
import '../Phosphor/icons/Pill.js';
import '../Phosphor/icons/PinterestLogo.js';
import '../Phosphor/icons/Pinwheel.js';
import '../Phosphor/icons/Pizza.js';
import '../Phosphor/icons/Placeholder.js';
import '../Phosphor/icons/Planet.js';
import '../Phosphor/icons/Plant.js';
import '../Phosphor/icons/Play.js';
import '../Phosphor/icons/PlayCircle.js';
import '../Phosphor/icons/PlayPause.js';
import '../Phosphor/icons/Playlist.js';
import '../Phosphor/icons/Plug.js';
import '../Phosphor/icons/PlugCharging.js';
import '../Phosphor/icons/Plugs.js';
import '../Phosphor/icons/PlugsConnected.js';
import '../Phosphor/icons/Plus.js';
import '../Phosphor/icons/PlusCircle.js';
import '../Phosphor/icons/PlusMinus.js';
import '../Phosphor/icons/PlusSquare.js';
import '../Phosphor/icons/PokerChip.js';
import '../Phosphor/icons/PoliceCar.js';
import '../Phosphor/icons/Polygon.js';
import '../Phosphor/icons/Popcorn.js';
import '../Phosphor/icons/PottedPlant.js';
import '../Phosphor/icons/Power.js';
import '../Phosphor/icons/Prescription.js';
import '../Phosphor/icons/Presentation.js';
import '../Phosphor/icons/PresentationChart.js';
import '../Phosphor/icons/Printer.js';
import '../Phosphor/icons/Prohibit.js';
import '../Phosphor/icons/ProhibitInset.js';
import '../Phosphor/icons/ProjectorScreen.js';
import '../Phosphor/icons/ProjectorScreenChart.js';
import '../Phosphor/icons/Pulse.js';
import '../Phosphor/icons/PushPin.js';
import '../Phosphor/icons/PushPinSimple.js';
import '../Phosphor/icons/PushPinSimpleSlash.js';
import '../Phosphor/icons/PushPinSlash.js';
import '../Phosphor/icons/PuzzlePiece.js';
import '../Phosphor/icons/QrCode.js';
import '../Phosphor/icons/Question.js';
import '../Phosphor/icons/Queue.js';
import '../Phosphor/icons/Quotes.js';
import '../Phosphor/icons/Radical.js';
import '../Phosphor/icons/Radio.js';
import '../Phosphor/icons/RadioButton.js';
import '../Phosphor/icons/Radioactive.js';
import '../Phosphor/icons/Rainbow.js';
import '../Phosphor/icons/RainbowCloud.js';
import '../Phosphor/icons/ReadCvLogo.js';
import '../Phosphor/icons/Receipt.js';
import '../Phosphor/icons/ReceiptX.js';
import '../Phosphor/icons/Record.js';
import '../Phosphor/icons/Rectangle.js';
import '../Phosphor/icons/Recycle.js';
import '../Phosphor/icons/RedditLogo.js';
import '../Phosphor/icons/Repeat.js';
import '../Phosphor/icons/RepeatOnce.js';
import '../Phosphor/icons/Rewind.js';
import '../Phosphor/icons/RewindCircle.js';
import '../Phosphor/icons/RoadHorizon.js';
import '../Phosphor/icons/Robot.js';
import '../Phosphor/icons/Rocket.js';
import '../Phosphor/icons/RocketLaunch.js';
import '../Phosphor/icons/Rows.js';
import '../Phosphor/icons/Rss.js';
import '../Phosphor/icons/RssSimple.js';
import '../Phosphor/icons/Rug.js';
import '../Phosphor/icons/Ruler.js';
import '../Phosphor/icons/Scales.js';
import '../Phosphor/icons/Scan.js';
import '../Phosphor/icons/Scissors.js';
import '../Phosphor/icons/Scooter.js';
import '../Phosphor/icons/Screencast.js';
import '../Phosphor/icons/ScribbleLoop.js';
import '../Phosphor/icons/Scroll.js';
import '../Phosphor/icons/Seal.js';
import '../Phosphor/icons/SealCheck.js';
import '../Phosphor/icons/SealQuestion.js';
import '../Phosphor/icons/SealWarning.js';
import '../Phosphor/icons/Selection.js';
import '../Phosphor/icons/SelectionAll.js';
import '../Phosphor/icons/SelectionBackground.js';
import '../Phosphor/icons/SelectionForeground.js';
import '../Phosphor/icons/SelectionInverse.js';
import '../Phosphor/icons/SelectionPlus.js';
import '../Phosphor/icons/SelectionSlash.js';
import '../Phosphor/icons/Shapes.js';
import '../Phosphor/icons/Share.js';
import '../Phosphor/icons/ShareFat.js';
import '../Phosphor/icons/ShareNetwork.js';
import '../Phosphor/icons/Shield.js';
import '../Phosphor/icons/ShieldCheck.js';
import '../Phosphor/icons/ShieldCheckered.js';
import '../Phosphor/icons/ShieldChevron.js';
import '../Phosphor/icons/ShieldPlus.js';
import '../Phosphor/icons/ShieldSlash.js';
import '../Phosphor/icons/ShieldStar.js';
import '../Phosphor/icons/ShieldWarning.js';
import '../Phosphor/icons/ShirtFolded.js';
import '../Phosphor/icons/ShootingStar.js';
import '../Phosphor/icons/ShoppingBag.js';
import '../Phosphor/icons/ShoppingBagOpen.js';
import '../Phosphor/icons/ShoppingCart.js';
import '../Phosphor/icons/ShoppingCartSimple.js';
import '../Phosphor/icons/Shower.js';
import '../Phosphor/icons/Shrimp.js';
import '../Phosphor/icons/Shuffle.js';
import '../Phosphor/icons/ShuffleAngular.js';
import '../Phosphor/icons/ShuffleSimple.js';
import '../Phosphor/icons/Sidebar.js';
import '../Phosphor/icons/SidebarSimple.js';
import '../Phosphor/icons/Sigma.js';
import '../Phosphor/icons/SignIn.js';
import '../Phosphor/icons/SignOut.js';
import '../Phosphor/icons/Signature.js';
import '../Phosphor/icons/Signpost.js';
import '../Phosphor/icons/SimCard.js';
import '../Phosphor/icons/Siren.js';
import '../Phosphor/icons/SketchLogo.js';
import '../Phosphor/icons/SkipBack.js';
import '../Phosphor/icons/SkipBackCircle.js';
import '../Phosphor/icons/SkipForward.js';
import '../Phosphor/icons/SkipForwardCircle.js';
import '../Phosphor/icons/Skull.js';
import '../Phosphor/icons/SlackLogo.js';
import '../Phosphor/icons/Sliders.js';
import '../Phosphor/icons/SlidersHorizontal.js';
import '../Phosphor/icons/Slideshow.js';
import '../Phosphor/icons/Smiley.js';
import '../Phosphor/icons/SmileyAngry.js';
import '../Phosphor/icons/SmileyBlank.js';
import '../Phosphor/icons/SmileyMeh.js';
import '../Phosphor/icons/SmileyNervous.js';
import '../Phosphor/icons/SmileySad.js';
import '../Phosphor/icons/SmileySticker.js';
import '../Phosphor/icons/SmileyWink.js';
import '../Phosphor/icons/SmileyXEyes.js';
import '../Phosphor/icons/SnapchatLogo.js';
import '../Phosphor/icons/Sneaker.js';
import '../Phosphor/icons/SneakerMove.js';
import '../Phosphor/icons/Snowflake.js';
import '../Phosphor/icons/SoccerBall.js';
import '../Phosphor/icons/SortAscending.js';
import '../Phosphor/icons/SortDescending.js';
import '../Phosphor/icons/SoundcloudLogo.js';
import '../Phosphor/icons/Spade.js';
import '../Phosphor/icons/Sparkle.js';
import '../Phosphor/icons/SpeakerHifi.js';
import '../Phosphor/icons/SpeakerHigh.js';
import '../Phosphor/icons/SpeakerLow.js';
import '../Phosphor/icons/SpeakerNone.js';
import '../Phosphor/icons/SpeakerSimpleHigh.js';
import '../Phosphor/icons/SpeakerSimpleLow.js';
import '../Phosphor/icons/SpeakerSimpleNone.js';
import '../Phosphor/icons/SpeakerSimpleSlash.js';
import '../Phosphor/icons/SpeakerSimpleX.js';
import '../Phosphor/icons/SpeakerSlash.js';
import '../Phosphor/icons/SpeakerX.js';
import '../Phosphor/icons/Spinner.js';
import '../Phosphor/icons/SpinnerGap.js';
import '../Phosphor/icons/Spiral.js';
import '../Phosphor/icons/SplitHorizontal.js';
import '../Phosphor/icons/SplitVertical.js';
import '../Phosphor/icons/SpotifyLogo.js';
import '../Phosphor/icons/Square.js';
import '../Phosphor/icons/SquareHalf.js';
import '../Phosphor/icons/SquareHalfBottom.js';
import '../Phosphor/icons/SquareLogo.js';
import '../Phosphor/icons/SquareSplitHorizontal.js';
import '../Phosphor/icons/SquareSplitVertical.js';
import '../Phosphor/icons/SquaresFour.js';
import '../Phosphor/icons/Stack.js';
import '../Phosphor/icons/StackOverflowLogo.js';
import '../Phosphor/icons/StackSimple.js';
import '../Phosphor/icons/Stairs.js';
import '../Phosphor/icons/Stamp.js';
import '../Phosphor/icons/Star.js';
import '../Phosphor/icons/StarAndCrescent.js';
import '../Phosphor/icons/StarFour.js';
import '../Phosphor/icons/StarHalf.js';
import '../Phosphor/icons/StarOfDavid.js';
import '../Phosphor/icons/SteeringWheel.js';
import '../Phosphor/icons/Steps.js';
import '../Phosphor/icons/Stethoscope.js';
import '../Phosphor/icons/Sticker.js';
import '../Phosphor/icons/Stool.js';
import '../Phosphor/icons/Stop.js';
import '../Phosphor/icons/StopCircle.js';
import '../Phosphor/icons/Storefront.js';
import '../Phosphor/icons/Strategy.js';
import '../Phosphor/icons/StripeLogo.js';
import '../Phosphor/icons/Student.js';
import '../Phosphor/icons/Subtitles.js';
import '../Phosphor/icons/Subtract.js';
import '../Phosphor/icons/SubtractSquare.js';
import '../Phosphor/icons/Suitcase.js';
import '../Phosphor/icons/SuitcaseRolling.js';
import '../Phosphor/icons/SuitcaseSimple.js';
import '../Phosphor/icons/Sun.js';
import '../Phosphor/icons/SunDim.js';
import '../Phosphor/icons/SunHorizon.js';
import '../Phosphor/icons/Sunglasses.js';
import '../Phosphor/icons/Swap.js';
import '../Phosphor/icons/Swatches.js';
import '../Phosphor/icons/SwimmingPool.js';
import '../Phosphor/icons/Sword.js';
import '../Phosphor/icons/Synagogue.js';
import '../Phosphor/icons/Syringe.js';
import '../Phosphor/icons/TShirt.js';
import '../Phosphor/icons/Table.js';
import '../Phosphor/icons/Tabs.js';
import '../Phosphor/icons/Tag.js';
import '../Phosphor/icons/TagChevron.js';
import '../Phosphor/icons/TagSimple.js';
import '../Phosphor/icons/Target.js';
import '../Phosphor/icons/Taxi.js';
import '../Phosphor/icons/TelegramLogo.js';
import '../Phosphor/icons/Television.js';
import '../Phosphor/icons/TelevisionSimple.js';
import '../Phosphor/icons/TennisBall.js';
import '../Phosphor/icons/Tent.js';
import '../Phosphor/icons/Terminal.js';
import '../Phosphor/icons/TerminalWindow.js';
import '../Phosphor/icons/TestTube.js';
import '../Phosphor/icons/TextAUnderline.js';
import '../Phosphor/icons/TextAa.js';
import '../Phosphor/icons/TextAlignCenter.js';
import '../Phosphor/icons/TextAlignJustify.js';
import '../Phosphor/icons/TextAlignLeft.js';
import '../Phosphor/icons/TextAlignRight.js';
import '../Phosphor/icons/TextB.js';
import '../Phosphor/icons/TextColumns.js';
import '../Phosphor/icons/TextH.js';
import '../Phosphor/icons/TextHFive.js';
import '../Phosphor/icons/TextHFour.js';
import '../Phosphor/icons/TextHOne.js';
import '../Phosphor/icons/TextHSix.js';
import '../Phosphor/icons/TextHThree.js';
import '../Phosphor/icons/TextHTwo.js';
import '../Phosphor/icons/TextIndent.js';
import '../Phosphor/icons/TextItalic.js';
import '../Phosphor/icons/TextOutdent.js';
import '../Phosphor/icons/TextStrikethrough.js';
import '../Phosphor/icons/TextT.js';
import '../Phosphor/icons/TextUnderline.js';
import '../Phosphor/icons/Textbox.js';
import '../Phosphor/icons/Thermometer.js';
import '../Phosphor/icons/ThermometerCold.js';
import '../Phosphor/icons/ThermometerHot.js';
import '../Phosphor/icons/ThermometerSimple.js';
import '../Phosphor/icons/ThumbsDown.js';
import '../Phosphor/icons/ThumbsUp.js';
import '../Phosphor/icons/Ticket.js';
import '../Phosphor/icons/TidalLogo.js';
import '../Phosphor/icons/TiktokLogo.js';
import '../Phosphor/icons/Timer.js';
import '../Phosphor/icons/Tipi.js';
import '../Phosphor/icons/ToggleLeft.js';
import '../Phosphor/icons/ToggleRight.js';
import '../Phosphor/icons/Toilet.js';
import '../Phosphor/icons/ToiletPaper.js';
import '../Phosphor/icons/Toolbox.js';
import '../Phosphor/icons/Tooth.js';
import '../Phosphor/icons/Tote.js';
import '../Phosphor/icons/ToteSimple.js';
import '../Phosphor/icons/Trademark.js';
import '../Phosphor/icons/TrademarkRegistered.js';
import '../Phosphor/icons/TrafficCone.js';
import '../Phosphor/icons/TrafficSign.js';
import '../Phosphor/icons/TrafficSignal.js';
import '../Phosphor/icons/Train.js';
import '../Phosphor/icons/TrainRegional.js';
import '../Phosphor/icons/TrainSimple.js';
import '../Phosphor/icons/Tram.js';
import '../Phosphor/icons/Translate.js';
import '../Phosphor/icons/Trash.js';
import '../Phosphor/icons/TrashSimple.js';
import '../Phosphor/icons/Tray.js';
import '../Phosphor/icons/Tree.js';
import '../Phosphor/icons/TreeEvergreen.js';
import '../Phosphor/icons/TreePalm.js';
import '../Phosphor/icons/TreeStructure.js';
import '../Phosphor/icons/TrendDown.js';
import '../Phosphor/icons/TrendUp.js';
import '../Phosphor/icons/Triangle.js';
import '../Phosphor/icons/Trophy.js';
import '../Phosphor/icons/Truck.js';
import '../Phosphor/icons/TwitchLogo.js';
import '../Phosphor/icons/TwitterLogo.js';
import '../Phosphor/icons/Umbrella.js';
import '../Phosphor/icons/UmbrellaSimple.js';
import '../Phosphor/icons/Unite.js';
import '../Phosphor/icons/UniteSquare.js';
import '../Phosphor/icons/Upload.js';
import '../Phosphor/icons/UploadSimple.js';
import '../Phosphor/icons/Usb.js';
import '../Phosphor/icons/User.js';
import '../Phosphor/icons/UserCircle.js';
import '../Phosphor/icons/UserCircleGear.js';
import '../Phosphor/icons/UserCircleMinus.js';
import '../Phosphor/icons/UserCirclePlus.js';
import '../Phosphor/icons/UserFocus.js';
import '../Phosphor/icons/UserGear.js';
import '../Phosphor/icons/UserList.js';
import '../Phosphor/icons/UserMinus.js';
import '../Phosphor/icons/UserPlus.js';
import '../Phosphor/icons/UserRectangle.js';
import '../Phosphor/icons/UserSquare.js';
import '../Phosphor/icons/UserSwitch.js';
import '../Phosphor/icons/Users.js';
import '../Phosphor/icons/UsersFour.js';
import '../Phosphor/icons/UsersThree.js';
import '../Phosphor/icons/Van.js';
import '../Phosphor/icons/Vault.js';
import '../Phosphor/icons/Vibrate.js';
import '../Phosphor/icons/Video.js';
import '../Phosphor/icons/VideoCamera.js';
import '../Phosphor/icons/VideoCameraSlash.js';
import '../Phosphor/icons/Vignette.js';
import '../Phosphor/icons/VinylRecord.js';
import '../Phosphor/icons/VirtualReality.js';
import '../Phosphor/icons/Virus.js';
import '../Phosphor/icons/Voicemail.js';
import '../Phosphor/icons/Volleyball.js';
import '../Phosphor/icons/Wall.js';
import '../Phosphor/icons/Wallet.js';
import '../Phosphor/icons/Warehouse.js';
import '../Phosphor/icons/Warning.js';
import '../Phosphor/icons/WarningCircle.js';
import '../Phosphor/icons/WarningDiamond.js';
import '../Phosphor/icons/WarningOctagon.js';
import '../Phosphor/icons/Watch.js';
import '../Phosphor/icons/WaveSawtooth.js';
import '../Phosphor/icons/WaveSine.js';
import '../Phosphor/icons/WaveSquare.js';
import '../Phosphor/icons/WaveTriangle.js';
import '../Phosphor/icons/Waveform.js';
import '../Phosphor/icons/Waves.js';
import '../Phosphor/icons/Webcam.js';
import '../Phosphor/icons/WebcamSlash.js';
import '../Phosphor/icons/WebhooksLogo.js';
import '../Phosphor/icons/WechatLogo.js';
import '../Phosphor/icons/WhatsappLogo.js';
import '../Phosphor/icons/Wheelchair.js';
import '../Phosphor/icons/WheelchairMotion.js';
import '../Phosphor/icons/WifiHigh.js';
import '../Phosphor/icons/WifiLow.js';
import '../Phosphor/icons/WifiMedium.js';
import '../Phosphor/icons/WifiNone.js';
import '../Phosphor/icons/WifiSlash.js';
import '../Phosphor/icons/WifiX.js';
import '../Phosphor/icons/Wind.js';
import '../Phosphor/icons/WindowsLogo.js';
import '../Phosphor/icons/Wine.js';
import '../Phosphor/icons/Wrench.js';
import '../Phosphor/icons/X.js';
import '../Phosphor/icons/XCircle.js';
import '../Phosphor/icons/XSquare.js';
import '../Phosphor/icons/YinYang.js';
import '../Phosphor/icons/YoutubeLogo.js';
import '@magnetic/theme';
import '../Empty/empty-state-info.js';
import '../Empty/empty-state-negative.js';
import '../Empty/empty-state-positive.js';
import '../Nav/index.js';
import { Status } from '../Status/index.js';
import { StatusIcon } from '../StatusIcon/index.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const statusMap = {
  alerting: "warning",
  down: "critical",
  offline: "critical",
  online: "good",
  warning: "warning",
  dormant: "inactive"
};
const backgroundStatusMap = {
  good: "var(--positive-bg-medium-default)",
  warning: "var(--warning-bg-medium-default)",
  critical: "var(--negative-bg-medium-default)",
  inactive: "var(--dormant-bg-medium-default)",
  info: "var(--info-bg-medium-default)"
};
const BackgroundSvg = /* @__PURE__ */ __name(({
  children,
  status
}) => /* @__PURE__ */ React.createElement("svg", {
  height: "28",
  viewBox: "0 0 28 28",
  width: "28"
}, /* @__PURE__ */ React.createElement("rect", {
  fill: backgroundStatusMap[status],
  height: "28",
  rx: "4",
  width: "28"
}), /* @__PURE__ */ React.createElement("svg", {
  x: "6",
  y: "6"
}, children)), "BackgroundSvg");
const iconMap = {
  good: (props) => /* @__PURE__ */ React.createElement(Status, {
    ...props,
    status: "good"
  }),
  warning: (props) => /* @__PURE__ */ React.createElement(Status, {
    ...props,
    status: "warning"
  }),
  critical: (props) => /* @__PURE__ */ React.createElement(Status, {
    ...props,
    status: "critical"
  }),
  inactive: (props) => /* @__PURE__ */ React.createElement(StatusIcon, {
    ...props,
    status: "inactive"
  }),
  info: (props) => /* @__PURE__ */ React.createElement(Status, {
    ...props,
    status: "info"
  })
};
const DeviceStatus = /* @__PURE__ */ __name(({
  background,
  clusterStatus,
  status: deviceStatus,
  ...rest
}) => {
  const status = useMemo(
    () => deviceStatus || statusMap[clusterStatus],
    [deviceStatus, clusterStatus]
  );
  const Svg = useMemo(() => iconMap[status], [status]);
  if (background) {
    return /* @__PURE__ */ React.createElement(BackgroundSvg, {
      status,
      ...rest
    }, /* @__PURE__ */ React.createElement(Svg, null));
  }
  return /* @__PURE__ */ React.createElement(Svg, {
    ...rest
  });
}, "DeviceStatus");

export { DeviceStatus };
//# sourceMappingURL=index.js.map
